import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { map, catchError } from 'rxjs/operators';

export interface LogEntry {
  date: string;
  time: string;
  file: string;
  line: number;
  message: string;
  timestamp?: number;
}

export interface LogResponse {
  records: LogEntry[];
  total: number;
  fileSize: number;
  lastModified: string;
}

export interface EventLogResponse {
  records: any[];
  total: number;
  fileSize: number;
  lastModified: string;
}

export interface EventLogFilters {
  search?: string;
  event?: string;
  request_id?: string;
  user_id?: string;
  target_user_id?: string;
  domain?: string;
  domain_id?: string;
  proposition_id?: string;
  date_from?: string;
  date_to?: string;
  limit?: number;
  offset?: number;
}

@Injectable({ providedIn: 'root' })
export class LogService {
  constructor(private httpClient: HttpClient) { }

  getLogs(search: string = '', limit: number = 500, offset: number = 0) {
    return this.httpClient.post<any>(`${environment.apiEndPoint}logs/read`, { search, limit, offset })
      .pipe(
        map(res => res ? res.document as LogResponse : null),
        catchError(this.handleError)
      );
  }

  getEvents(filters: EventLogFilters = {}) {
    return this.httpClient.post<any>(`${environment.apiEndPoint}logs/read_events`, {
      limit: 1000,
      offset: 0,
      ...filters
    })
      .pipe(
        map(res => res ? res.document as EventLogResponse : null),
        catchError(this.handleError)
      );
  }

  private handleError(error: any): Promise<any> {
    let retour = error?.error?.message || error?.message || error;
    if (error?.error?.data) retour += '<br />' + error?.error?.data;
    return Promise.reject(retour);
  }
}
